import React from 'react';
import {Popup} from 'semantic-ui-react';

function renderAvatar(userLetter) {
  return (
    <div className="container__record-message-avatar">
      <div>{userLetter}</div>
    </div>
  );
}

const Message = ({user, message, username, date}) => {
  const userStyle = user ? 'user-style' : '';
  const userLetter = username && username.length > 1 ? username[0] + username[1] : 'DS';

  return (
    <div className={`container__record-message animated fadeInUp ${userStyle}`} >
      {!user && <Popup content={username} trigger={renderAvatar(userLetter)} />}
      <div className={`container__record-message-body ${userStyle}`} >
        <div className={`container__record-message-body-date ${userStyle}`}>
          {date.replace('T', '   ')}
        </div>
        <div>{message}</div>
      </div>
    </div>
  );
};

export default Message;
